import React, { useState, useEffect } from 'react';
import { useMobileDetection } from '../../../../../hooks/useMobileDetection';

export function ControlInstructions({ isLocked, isViewMode }) {
    const { isMobile, isTouch } = useMobileDetection();

    if (isLocked) {
        return (
            <div style={{
                position: 'absolute',
                bottom: '20px',
                right: '20px',
                background: 'rgba(0, 0, 0, 0.6)',
                color: 'white',
                fontSize: '0.813rem',
                padding: '0.5rem 0.875rem',
                borderRadius: '4px',
                opacity: 0.9,
                pointerEvents: 'none',
                zIndex: 4,
                backdropFilter: 'blur(8px)',
                letterSpacing: '0.02em',
                fontWeight: 500
            }}>
{isMobile ? 'Tap to release touch' : 'C to toggle first person mode'}
            </div>
        );
    }

    if (isViewMode && !isLocked) {
        return (
            <div style={{
                position: 'absolute',
                bottom: '20px',
                right: '20px',
                background: 'rgba(0, 0, 0, 0.6)',
                color: 'white',
                fontSize: '0.813rem',
                padding: '0.5rem 0.875rem',
                borderRadius: '4px',
                opacity: 0.7,
                pointerEvents: 'none',
                zIndex: 4,
                backdropFilter: 'blur(8px)',
                letterSpacing: '0.02em',
                fontWeight: 500
            }}>
{isMobile ? 'Touch to look around' : 'Click to look around'}
            </div>
        );
    }

    // Old tooltip removed - now handled by FloatingTooltip component in Scene.js

    return null;
}

 